export default "__VITE_ASSET__Dl4VN_7t__"